import { render, staticRenderFns } from "./DosyadakiIbanBilgisininGuncellenmesiTalepEvrakForm.vue?vue&type=template&id=37dbc22b"
import script from "./DosyadakiIbanBilgisininGuncellenmesiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./DosyadakiIbanBilgisininGuncellenmesiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports